import { graphqlClient } from '@/lib/graphql-client';
import { buildGetDesignationsQuery } from '../graphql/queries';
import { INSERT_DESIGNATION_MUTATION, UPDATE_DESIGNATION_MUTATION } from '../graphql/mutations';
import {
  DesignationInsertInput,
  DesignationsPagingResult,
  DesignationUpdateInput,
  GetDesignationsParams,
} from '../types/designation.types';

export const getDesignations = async (
  params: GetDesignationsParams
): Promise<{ Designations: DesignationsPagingResult }> => {
  const { pageNo, pageSize, filter = {}, order } = params;
  return graphqlClient.query({
    query: buildGetDesignationsQuery(filter, pageNo, pageSize, order),
  });
};

export const createDesignation = async (input: DesignationInsertInput) => {
  return graphqlClient.mutate({
    query: INSERT_DESIGNATION_MUTATION,
    variables: { input },
  });
};

export const updateDesignation = async (params: {
  itemId: string;
  input: DesignationUpdateInput;
}) => {
  const filter = JSON.stringify({ _id: params.itemId });
  return graphqlClient.mutate({
    query: UPDATE_DESIGNATION_MUTATION,
    variables: { filter, input: params.input },
  });
};
